exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userInfoBox{position:relative}.userInfoBox .van-field__body input{text-align:right}.userInfoBox .adr .van-cell__title{flex:0.2;-webkit-box-flex:0.2;-webkit-flex:0.2}", ""]);

// exports
